export /**
 *
 *
 * @param {*} inputData
 * @return {*}
 */
const formatExcelData = (inputData) => {
  const formattedData = inputData.map((data) => {
    const { customerName, ...rest } = data;

    return {
      Navn: customerName,
      ...rest,
    };
  });

  return formattedData;
};
